import React from 'react'
import { FaChevronRight } from 'react-icons/fa6'

function WorkforceManagementsec4() {
  return (
    <section className='abtcont'>
            <div className='container'>
                <h3>Your Partner in Business Optimization</h3>
                <p style={{maxWidth: "750px", margin: "0 auto 20px"}}>Workface is more than just software—it’s a smart solution designed to enhance your existing business infrastructure. Whether you need automated employee management, remote tracking, financial processing, or geolocation services, we help you achieve seamless operations without replacing your ERP systems.</p>
                <h3>Get Started Today!</h3>
                <p style={{maxWidth: "750px", margin: "0 auto 20px"}}>Transform the way you manage your workforce with Workface. Contact us to schedule a demo and experience seamless integration, automation, and smarter workforce solutions. Your success is our priority!</p>
                <button className='btn-main' onClick={() => window.location.href = '/contact'}><span>Contact Us</span> <FaChevronRight/></button>
            </div>
        </section>
  )
}

export default WorkforceManagementsec4
